import { Block } from 'webiq.boilerplate'

export default class BoilerplatePopup extends Block {
	static title = 'popup'

	init() {
		this.overlay = document.querySelector('.overlay--main')

		this.closeButton = this.getElement('close')
		if (this.closeButton) {
			this.closeButton.addEventListener('click', () => this.close())

			this.closeButton.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault()
					this.closeButton.click()
				}
			})
		}

		if (this.overlay) {
			this.overlay.addEventListener('click', () => this.close())
		}
	}

	toggle() {
		if (this.hasModifier('hidden') || !this.hasModifier('active')) {
			this.open()
			return
		}
		this.close()
	}

	open() {
		this.removeModifier('hidden')
		this.addModifier('active')
		this.eventEmitter.emit('popup:open')
		this.element.querySelector('[tabindex="0"]').focus()
	}

	close() {
		this.addModifier('hidden')
		this.removeModifier('active')
		this.eventEmitter.emit('popup:close')
		document.querySelector('.logo--header').focus()
	}
}
